import { Circle } from "lucide-react"
import { ReactElement } from "react"
import { Badge } from "../atoms/Badge"
import { cn } from "../utils"

export type BadgePingTextProps = {
  color: "success" | "warning" | "error"
  text?: string
  children?: ReactElement
}
export const BadgePingText = ({ color, text, children }: BadgePingTextProps) => {
  const circleColor = {
    success: "fill-emerald-500 text-emerald-500",
    warning: "fill-yellow-500 text-yellow-500",
    error: "fill-red-500 text-red-500",
  }[color]

  return (
    <Badge variant="outline" className="h-9">
      <span className="flex gap-1.5 items-center">
        <span className="relative">
          <Circle
            className={cn("scale-75 animate-ping", circleColor)}
            style={{ animationDuration: "2000ms" }} // NOTE: Can't set it using tailwind
            size={12}
          />
          <Circle className={cn("scale-75 absolute top-0", circleColor)} size={12} />
        </span>
        <span>{children ?? text}</span>
      </span>
    </Badge>
  )
}
